module.exports = __webpack_public_path__ + "media/img/masks/sad-face-dcb56a72745e8db2d489002f9fa62b0b.svg";